var _path, _circle, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineOrderCancelled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.5L16 8.5M16 8.5L15.5 8.75L11 11M16 8.5V12M16 8.5L6.5 3.5M11 11L2 6.5M11 11V20.5M14.578 2.382L16.578 3.432C18.729 4.561 19.805 5.125 20.403 6.14C21 7.154 21 8.417 21 10.942V11.059C18 11.5 16.8357 12.9302 16.5 13.5C16.1391 14.1125 15.5 15.5 16.578 18.569L14.578 19.618C12.822 20.539 11.944 21 11 21C10.056 21 9.178 20.54 7.422 19.618L5.422 18.568C3.271 17.439 2.195 16.875 1.597 15.86C1 14.846 1 13.583 1 11.06V10.943C1 8.418 1 7.155 1.597 6.141C2.195 5.126 3.271 4.561 5.422 3.433L7.422 2.383C9.178 1.461 10.056 1 11 1C11.944 1 12.822 1.46 14.578 2.382Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 16,
    r: 4.5,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4845 14.0352C19.3103 14.0774 19.2081 14.1798 19.118 14.3967C18.9978 14.686 19.0879 14.8547 19.6828 15.4572L20.2057 15.9815L19.6528 16.5418C19.3463 16.8431 19.0699 17.1745 19.0338 17.2649C18.9016 17.6324 19.172 18 19.5807 18C19.797 18 19.8571 17.9518 20.416 17.3974L21.0169 16.7949L21.5397 17.3191C21.8342 17.6023 22.1286 17.8674 22.2068 17.9096C22.6094 18.1145 23.1442 17.5782 22.9399 17.1745C22.8978 17.1022 22.6334 16.8009 22.351 16.5117L21.8342 15.9815L22.4171 15.391C22.9459 14.8487 23 14.7703 23 14.5715C23 14.1497 22.5673 13.8725 22.2008 14.0593C22.1286 14.0955 21.8342 14.3606 21.5457 14.6438L21.0169 15.162L20.458 14.6076C20.1456 14.3003 19.8631 14.0533 19.8271 14.0533C19.791 14.0533 19.7309 14.0412 19.6828 14.0292C19.6408 14.0171 19.5506 14.0232 19.4845 14.0352Z",
    fill: "#E70000"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineOrderCancelled);
export default __webpack_public_path__ + "static/media/onlineOrderCancelled.c38da6c7d567a3c420772ad02d1ced62.svg";
export { ForwardRef as ReactComponent };